<template>
  <b-form-group
    label="Metin Değeri 3"
    label-for="str_value_3"
  >
    <b-form-input
      id="str_value_3"
      v-model="dataItem.str_value_3"
      placeholder="Metin Değeri 3"
    />
  </b-form-group>
</template>

<script>
import { localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'ParamsStringValue3',
  components: {
    BFormGroup,
    BFormInput,

  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['params/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>

<style scoped>

</style>
